<button
    mat-button
    (click)="buttonClick()"
    [ngClass]="color"
>
    {{ title }}
</button>
